<template>
  <div>
    <div class="flex-x-center">
      <div class="profile-content">
        <div class="project-content" v-html="process.content"></div>
      </div>
    </div>

    <div class="flex-x-center agree-sign-next">
      <el-checkbox v-model="kswjModel.check" :disabled="kswjModel.disable === 1" class="agree-pro">{{ process.tips
      }}</el-checkbox>
      <button v-show="process.enable == 1" class="next-step" @click="checkKswj()">
        下一步
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { erroralert, successalert } from "@/utils/alert";
export default {
  data() {
    return {
      kswjModel: {
        check: false,
        disable: 0,
      },
    };
  },

  mounted() {
    if (this.$parent.projectDetail.current_step > this.process_index) {
      this.kswjModel.check = true;
      this.kswjModel.disable = 1;
    }
  },
  props: {
    // 流程
    process_index: 0,
    process: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  methods: {
    ...mapActions(useMainStore, {
      changeProject: "updateProjectDetail",
    }),
    //考生文件
    checkKswj() {
      if (this.kswjModel.check !== true) {
        erroralert(this.process.tips);
        return;
      }
      //调用父组件，进入下一步
      this.$parent.next();
    },
  },
};
</script>

<style>
/* p b {
  font-weight: 500;
  color: #000;
  font-size: 18px;
}
div span {
  font-size: 13px;
}
.MsoNormal {
  font-size: 16px;
  
} */
.profile-content {
  font-size: 14px;
  margin-top: 20px;
  width: 83%;
  padding: 40px 50px 80px;
  background: white !important;
  border-radius: 5px;
  box-sizing: border-box;
}
</style>
